import script from "./ProfileChildren.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileChildren.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileChildren.vue?vue&type=style&index=0&id=95328d9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95328d9e"]])

export default __exports__